import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-team-stacking/actions';

class ForceTeamsToStacking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.setTeamsAreForcedToStacking(isChecked));
    }

    render() {
        const {stacking} = this.props;
        const isChecked = stacking.isTeamsForcedToStacking();

        return (
            <label>
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
                Force teams to stacking
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(ForceTeamsToStacking);
